import { type FC } from 'react';
import { ConstructSucces } from '@common/components/ConstructSuccess/ConstructSuccess';
import { type ResourceTypeText } from '@common/types/resource';
import { selectQuarryByIdOrName } from '@redux/selectors/quarrySelectors';
import { useAppSelector } from '@redux/store';

interface QuarryBuildCompleteProps {
  name: ResourceTypeText;
}

const QuarryBuildComplete: FC<QuarryBuildCompleteProps> = ({ name }) => {
  const quarry = useAppSelector((state) => selectQuarryByIdOrName(state, name));

  return (
    quarry && (
      <ConstructSucces
        name={quarry.name}
        kind="quarry"
        id={quarry.id}
        level={quarry.level}
      />
    )
  );
};

export { QuarryBuildComplete };
